import React from 'react';
import PropTypes from 'prop-types';

import flow from 'lodash/flow';

import {
  Button,
  FormLayout,
  Heading,
  HorizontalRule,
  IconStatusConfirmationOnlight,
  LogoHsbcGlobal,
  Paragraph,
  Section,
  withTrackPage,
} from '@piggybank/core';

import {
  Form,
} from '@piggybank/form';

import styles from './success-page.module.css';

import SuccessCreditInformationPanel from '~/components/SuccessCreditInformationPanel';
import TopUpOhcSuccessCreditInformationPanel from '~/components/TopUpOhcSuccessCreditInformationPanel';
import DiSuccessCreditInformationPanel from '~/components/DiSuccessCreditInformationPanel';

import { isButtonVisible, isHeaderVisible, NLS } from './successPageFunctions';
import { immediateVisible, refillVisible, simpleKronerVisible, topUpOhcVisible } from '~/genericFunctions';

import { withAppContext } from '~/AppContext';

import getEnvironment from '~/lib/environment';

const environment = getEnvironment();

const SuccessPage = ({ data }) => (
  <FormLayout>
    <Section marginBottom={3}>
      {isHeaderVisible(data.displayData.globalData.ismobile) &&
        <div className={styles.container}>
          <LogoHsbcGlobal />
        </div>
      }
      <div className={styles.confirmation}>
        <IconStatusConfirmationOnlight width="3em"/>
      </div>
      <Heading level={1}>{NLS`Congratulations! Your request was successfully registered`}</Heading>
      <HorizontalRule />
    </Section>
    <Section>
      { simpleKronerVisible(data.displayData.globalData.type) &&
        <SuccessCreditInformationPanel />
      }
      { topUpOhcVisible(data.displayData.globalData.type) &&
        <TopUpOhcSuccessCreditInformationPanel />
      }
      { (immediateVisible(data.displayData.globalData.type) || refillVisible(data.displayData.globalData.type)) &&
        <DiSuccessCreditInformationPanel />
      }
    </Section>
    <Section>
      <Paragraph>{NLS`Regarding the credits contracted with HSBC México, S.A., remember that at any time you can cancel the automatic collection instruction or request the direct debit of the payment of the referred credits in the accounts that you keep in other banks. If you wish to carry out this procedure, go to any of our branches.`}</Paragraph>
      { (simpleKronerVisible(data.displayData.globalData.type) ||
        topUpOhcVisible(data.displayData.globalData.type) ||
        immediateVisible(data.displayData.globalData.type)) &&
        <Paragraph>{NLS`Go to your branch for your Contract, Cover, Commission Annex and Amortization Table`}</Paragraph>
      }
      { refillVisible(data.displayData.globalData.type) &&
        <Paragraph>{NLS`Go to your branch for your Contract, Cover and Annex of Commissions.`}</Paragraph>
      }
      {isButtonVisible(data.displayData.globalData.ismobile) &&
        <>
          <HorizontalRule hiddenOnSmallViewport />
          <Form children={<Button elementType="a" href={environment.bankingDashboardUrl} target="_self">{NLS`Finish`}</Button>} initialValues={{}} />
        </>
      }
    </Section>
  </FormLayout>
);

SuccessPage.propTypes = {
  data: PropTypes.shape({
    displayData: PropTypes.shape({
      globalData: PropTypes.shape({
        ismobile: PropTypes.string,
        type: PropTypes.string,
      }),
    }),
  }),
};

export default flow(
  withAppContext(),
  withTrackPage('loanSuccess', 'component')
)(SuccessPage);
